import BulbIcon from '~/components/AiChat/SideBarDialog/icons/BulbIcon';
import ClaimMilestonesIcon from '~/components/ClaimMilestones/ClaimMilestonesIcon';
import {
  AiChatIcon,
  ClipboardIcon,
  CommunicationIcon,
  ContactsIcon,
  DocumentIcon,
  FinancesIcon,
  FormIcon,
  GalleryIcon,
  GavelIcon,
  ManagementIcon,
  PolicyIcon,
  RelatedClaimsIcon,
  TrayIcon,
} from '~/components/icons';
import { CustomIcon } from '~/components/icons/lobs';
import NoteTabIcon from '~/components/icons/NoteTabIcon';
import type { IconProps } from '~/components/icons/types';

import type { ClaimSidebarFieldConfiguration } from './types';

type SidebarFieldKey = ClaimSidebarFieldConfiguration['field_key'];

export const sidebarFieldKeyToIconComponent: Record<SidebarFieldKey, React.ComponentType<IconProps>> = {
  summary: ClipboardIcon,
  management: ManagementIcon,
  notes: NoteTabIcon,
  legal_actions: GavelIcon,
  finances: FinancesIcon,
  communications: CommunicationIcon,
  contacts: ContactsIcon,
  documents: DocumentIcon,
  gallery: GalleryIcon,
  policy: PolicyIcon,
  related_claims: RelatedClaimsIcon,
  osha: FormIcon,
  notifications: TrayIcon,
  clive_chat: AiChatIcon,
  clive_insights: BulbIcon,
  conductor_hub: CustomIcon,
  milestones: ClaimMilestonesIcon,
} as const;

export const lobIdentifierRegex = /{{\s*lob\s*}}/gi;
